module.exports = __webpack_public_path__ + "img/9788992555784.61743579.jpg";